import React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Switch } from 'antd';
import { DragMore } from 'common/components/svgs';

export default function SettingTable({ data = [], setData, t }) {
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const handleDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const { destination, source } = result;
    const tempData = [...data];
    const items = reorder(tempData, source.index, destination.index);
    items.forEach((item, index) => (item.position = index));
    setData(items);
  };

  const handleSwitchChange = (value, switchName) => {
    let tempData = [...data];
    const targetSettingIndex = tempData.findIndex(item => item.name === switchName);
    if (targetSettingIndex !== -1) {
      tempData.splice(targetSettingIndex, 1, {
        ...tempData[targetSettingIndex],
        enabled: value,
      });
    }
    setData(tempData);
  };

  return (
    <div
      className="drag-table-wrapper"
      style={{ height: data.length > 0 ? 49 + data.length * 50 + 'px' : 150 }}
    >
      <div className="drag-table-header">
        <span className="drag-title">
          {t('cms.dashboard.strategy.homepage_setting.modal_setting.all_sessions')}
        </span>
      </div>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <For of={data} each="item" index="index">
                <Draggable draggableId={String(item.position)} key={item.position} index={index}>
                  {provided => (
                    <div
                      {...provided.dragHandleProps}
                      {...provided.draggableProps}
                      ref={provided.innerRef}
                      className="table-item"
                    >
                      <div className="table-item-left">
                        <DragMore className="more-icon" />
                        <span className="cursor">{index + 1}</span>
                        <span>{t(`cms.dashboard.strategy.module_setting.${item.name}`)}</span>
                      </div>
                      <Switch
                        checked={item.enabled}
                        onChange={value => handleSwitchChange(value, item.name, index)}
                      />
                    </div>
                  )}
                </Draggable>
              </For>
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}
